import { render } from "./ProductInfo.vue?vue&type=template&id=0da1604a&scoped=true"
import script from "./ProductInfo.js?vue&type=script&lang=js"
export * from "./ProductInfo.js?vue&type=script&lang=js"

import "./ProductInfo.scss?vue&type=style&index=0&id=0da1604a&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./ProductInfo.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FPageProductDetail%2FProductInfo%2FProductInfo.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da1604a"]])

export default __exports__